import React from "react";
import { Box, Tooltip } from "@mui/material";
import tbpLogo from "assets/tbp_logo.png";
import vkLogo from "assets/vk.svg";
import telegramLogo from "assets/telegram.svg";
import maxLogo from "assets/max.svg";
import fastLogo from "assets/fast.svg";

const sources = {
  tbp: { icon: tbpLogo, label: "Товар без переплат" },
  vk_mini_app: { icon: vkLogo, label: "VK" },
  tg_mini_app: { icon: telegramLogo, label: "Telegram" },
  max_mini_app: { icon: maxLogo, label: "MAX" },
};

export const OrderSource = ({ source }) => {
  const isFastOrder = typeof source === "string" && source.endsWith("_fast_order");
  const platform = isFastOrder ? source.slice(0, -"_fast_order".length) : source;
  const config = sources[platform];

  if (!config?.icon || (isFastOrder && platform === "tbp")) return null;

  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: "4px", flexShrink: 0, transform: "translateY(-2px)" }}>
      <Tooltip title={`Источник заказа: ${config.label}`}>
        <img src={config.icon} alt={config.label} width={24} height={24} style={{ objectFit: "contain" }} />
      </Tooltip>
      {isFastOrder && (
        <Tooltip title="Быстрый заказ">
          <img src={fastLogo} alt="Быстрый заказ" width={24} height={24} style={{ objectFit: "contain" }} />
        </Tooltip>
      )}
    </Box>
  );
};
